const reducer = (state, action) => {
    switch (action.type) {
        case 'account-name':
            return {
                ...state,
                accountName: action.payload,
            };
        case 'account-number':
            return {
                ...state,
                accountNumber: action.payload,
            };
        case 'action':
            return {
                ...state,
                action: action.payload,
            };
        default:
            return state;
    }
};
const receiverDetailsReducer = (state, action) => {
    const newState = reducer(state, action);
    if (process.env.NODE_ENV === 'development') {
        // eslint-disable-next-line no-console
        console.log('%cReceiver details form', 'color: green; font-weight: bold', action, 'new state', newState);
    }
    return newState;
};
export default receiverDetailsReducer;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVkdWNlci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL1JlY2VpdmVyRGV0YWlscy9mb3JtL3JlZHVjZXIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBR0EsTUFBTSxPQUFPLEdBQUcsQ0FBQyxLQUEyQixFQUFFLE1BQTZCLEVBQXdCLEVBQUU7SUFDakcsUUFBUSxNQUFNLENBQUMsSUFBSSxFQUFFLENBQUM7UUFDbEIsS0FBSyxjQUFjO1lBQ2YsT0FBTztnQkFDSCxHQUFHLEtBQUs7Z0JBQ1IsV0FBVyxFQUFFLE1BQU0sQ0FBQyxPQUFPO2FBQzlCLENBQUM7UUFDTixLQUFLLGdCQUFnQjtZQUNqQixPQUFPO2dCQUNILEdBQUcsS0FBSztnQkFDUixhQUFhLEVBQUUsTUFBTSxDQUFDLE9BQU87YUFDaEMsQ0FBQztRQUNOLEtBQUssUUFBUTtZQUNULE9BQU87Z0JBQ0gsR0FBRyxLQUFLO2dCQUNSLE1BQU0sRUFBRSxNQUFNLENBQUMsT0FBTzthQUN6QixDQUFDO1FBQ047WUFDSSxPQUFPLEtBQUssQ0FBQztJQUNyQixDQUFDO0FBQ0wsQ0FBQyxDQUFDO0FBRUYsTUFBTSxzQkFBc0IsR0FBRyxDQUFDLEtBQTJCLEVBQUUsTUFBNkIsRUFBd0IsRUFBRTtJQUNoSCxNQUFNLFFBQVEsR0FBRyxPQUFPLENBQUMsS0FBSyxFQUFFLE1BQU0sQ0FBQyxDQUFDO0lBQ3hDLElBQUksT0FBTyxDQUFDLEdBQUcsQ0FBQyxRQUFRLEtBQUssYUFBYSxFQUFFLENBQUM7UUFDekMsc0NBQXNDO1FBQ3RDLE9BQU8sQ0FBQyxHQUFHLENBQUMseUJBQXlCLEVBQUUsaUNBQWlDLEVBQUUsTUFBTSxFQUFFLFdBQVcsRUFBRSxRQUFRLENBQUMsQ0FBQztJQUM3RyxDQUFDO0lBQ0QsT0FBTyxRQUFRLENBQUM7QUFDcEIsQ0FBQyxDQUFDO0FBRUYsZUFBZSxzQkFBc0IsQ0FBQyJ9